module.exports = __webpack_public_path__ + "img/stop_btn.004a3700.png";